<template>
    <TestResult :data="result">
        <a href="javascript:;" class="open-app-btn" @click="clickOpenBtn">打开回森测试音色</a>
    </TestResult>
</template>

<script setup>
import { ref, watch, computed } from 'vue';
import { onMounted, nextTick, getCurrentInstance } from 'vue';
import { isWechat } from '@/lib/utils';
import { useFetchData } from '@/lib/hooks';
import setWechatShare from '@/lib/wechat-share';
import TestResult from '../../activity/testTimbre/components/TestResult.vue';
import { openAppWebview } from '@/lib/scheme';
import { getQueryValue } from '@/lib/utils';
import { getTimbreTestResult } from '../service';

const { proxy } = getCurrentInstance();

const reportId = getQueryValue('reportId');

const result = ref({});
const [reportResult] = useFetchData(getTimbreTestResult, {reportId}, true);
const exchangeResult = (data) => {
    result.value = {
        ...data,
    };
    if(data.voiceResult !== '独具一格の神秘音'){
        const singerName = data?.similarSinger?.match(/与(.+)声音相似度/)[1];
        result.value.similarSinger = data?.similarSinger?.split(new RegExp(new RegExp('(' + singerName + ')')));
        result.value.voiceRareness = data?.voiceRareness?.split(/([\.\d]+%)/)?.slice(1);
    }
};
watch(reportResult, () => {
    if(reportResult?.status === 0){
        exchangeResult(reportResult.data);
        setCustomWechatShare();
    }
});

const clickOpenBtn = () => {
    proxy.$weblog.click('OPEN_HUISEN');
};

// 微信开放标签
const addWechatTag = () => {
    nextTick(() => {
        const schemeUrl = openAppWebview({ url: `${location.origin}/html/mulight-web/activity/testTimbre/index.html?__titlebar=0&__statusBarDarkFont=false`, jump: false });

        proxy.$launchApp.changeFbUrl(proxy.$launchApp.fbUrl + `&scheme=${encodeURIComponent(schemeUrl)}`);

        proxy.$launchApp.bindLaunchAppEvent(document.querySelectorAll('.open-app-btn'), schemeUrl);
    });
};

// 微信二次分享
const setCustomWechatShare = () => {
    if (isWechat()) {
        setWechatShare(
            {
                title: `我竟然是${result?.value?.voiceResult}`,
                img: 'https://static.yximgs.com/udata/pkg/phenix/icon_share.bd7641722bdcc87d.jpg',
                desc: `来回森，测试你的声音`,
                link: location.href.split('#')[0],
            }
        );
    }
};

onMounted(() => {
    nextTick(() => {
        addWechatTag();
    });
});
</script>

<style lang="scss">
@import '~@css/common.css';
html,body, #app{
    height: 100%;
}
</style>

<style lang="scss" scoped>
.open-app-btn{
    margin: 68px auto 80px auto;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 550px;
    height: 112px;
    background: #ffe42c;
    border-radius: 56px;
    font-size: 36px;
    font-family: PingFang SC, PingFang SC-Semibold;
    font-weight: 600;
    color: #010101;
}
</style>
